export default function ForInvestors() {
  return (
    <section id="for-investors" className="py-16 md:py-[110px]">
      <div className="max-w-[1120px] mx-auto px-5 md:px-10">
        <h2 className="text-[24px] md:text-[30px] font-semibold text-[#1E2430] mb-[14px]">
          For Investors
        </h2>
        
        <div className="max-w-[720px]">
          <p className="text-[17px] leading-[1.65] text-[#5B6475] mb-6">
            Valaxis Group pursues acquisitions where disciplined execution, operational leverage, and strategic clarity create asymmetric value opportunities.
          </p>
          
          <p className="text-[17px] leading-[1.65] text-[#5B6475] mb-6">
            Our investment approach emphasizes:
          </p>
          
          <ul className="space-y-3 mb-6">
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Operator-driven value creation
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Risk-aware capital deployment
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Long-term value orientation
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Alignment of incentives
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[#2E3A59] mt-1">•</span>
              <span className="text-[17px] leading-[1.65] text-[#5B6475]">
                Scalable growth platforms
              </span>
            </li>
          </ul>
          
          <p className="text-[17px] leading-[1.65] text-[#5B6475]">
            We seek partnerships with investors who value patience, rigor, and operational excellence.
          </p>
        </div>
      </div>
    </section>
  );
}
